import styled from 'styled-components';
import Btn from 'components/atoms/Btn';

export const MoveButtonContainer = styled.div`
    padding: 12px 20px;
`;

export const BtnNext = styled(Btn)``;